import React from 'react';
import StatusBar from 'design-system/StatusBar';
import { AppView, withAnimatedNavigationHeader } from 'design-system';
import GroupsList from 'features/group/components/GroupsList';
const AddToGroupScreen = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const { contact, transactions, isSelectGroup, addTransactionCallback } = route.params;
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <GroupsList contact={contact} isSelectGroup={isSelectGroup} transactions={transactions} onScroll={scrollHandler} addTransactionCallback={addTransactionCallback}/>
        </AppView>);
}, ({ colors }) => ({
    title: 'Select a group',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default AddToGroupScreen;
